import { useId } from 'react';
import { getSevereWeatherAlertTextSections } from '../../utils/severeWeatherAlerts.utils';

const SevereWeatherAlertDescription = ({ description, compact = false }) => {
  const headingId = useId();
  const descriptionSections = getSevereWeatherAlertTextSections(description);

  if (!descriptionSections.length) return null;

  return (
    <section aria-labelledby={headingId}>
      <h3 id={headingId} className={`mb-1 fw-semibold ${compact ? 'small' : 'fs-6'}`}>
        Description
      </h3>
      {descriptionSections.length === 1 ? (
        <p className={`m-0 text-break ${compact ? 'small' : ''}`}>{descriptionSections[0]}</p>
      ) : (
        <ul
          className={`m-0 d-flex flex-column gap-1 text-break ${compact ? 'small ps-3' : 'ps-4'}`}
        >
          {descriptionSections.map((descriptionSection, sectionIndex) => (
            <li key={`${sectionIndex}:${descriptionSection}`}>{descriptionSection}</li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default SevereWeatherAlertDescription;
